import {formatCurrency} from '../../../utils';
import {previewGross} from '../utils/movementUtils';
import AccountSelect from '../../../components/common/AccountSelect';
import ProjectSelect from '../../../components/common/ProjectSelect';

const IncomeForm = ({form, onChange, accounts, projects, editId, onSubmit, onCancel, saving}) => {
    const set = (key, val) => onChange({...form, [key]: val});
    const gross = previewGross(form);

    const canSubmit = form.accountId && form.occurredOn && form.currencyCode &&
        (form.type === 'FIXED' ? form.amount
            : form.type === 'RATE_BASED' ? form.rate && form.days && form.sharePercent
            : form.adjustment);

    return (
        <form className="tx-form" onSubmit={(e) => { e.preventDefault(); if (canSubmit) onSubmit(); }}>
            <h3 className="tx-form__title">{editId ? 'Edit Income' : 'Add Income'}</h3>

            <div className="tx-form__type-tabs">
                {[['FIXED', 'Fixed'], ['RATE_BASED', 'Rate Based'], ['REVALUATION', 'Revaluation']].map(([v, l]) => (
                    <button key={v} type="button"
                            className={`tx-form__type-tab${form.type === v ? ' is-active' : ''}`}
                            onClick={() => set('type', v)}>
                        {l}
                    </button>
                ))}
            </div>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Date</label>
                    <input className="tx-form__input" type="date" value={form.occurredOn}
                           onChange={e => set('occurredOn', e.target.value)} required/>
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">Currency</label>
                    <input className="tx-form__input" placeholder="EUR" maxLength={3}
                           value={form.currencyCode}
                           onChange={e => set('currencyCode', e.target.value.toUpperCase())} required/>
                </div>
            </div>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Account</label>
                    <AccountSelect
                        accounts={accounts}
                        value={form.accountId}
                        onChange={v => set('accountId', v)}
                    />
                </div>
                {form.type !== 'REVALUATION' && (
                    <div className="tx-form__field">
                        <label className="tx-form__label">Project <span className="tx-form__optional">(optional)</span></label>
                        <ProjectSelect
                            projects={projects}
                            value={form.projectId}
                            onChange={v => set('projectId', v)}
                        />
                    </div>
                )}
            </div>

            {form.type === 'FIXED' && (
                <div className="tx-form__row">
                    <div className="tx-form__field">
                        <label className="tx-form__label">Amount</label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                               value={form.amount} onChange={e => set('amount', e.target.value)} required/>
                    </div>
                    <div className="tx-form__field">
                        <label className="tx-form__label">Deduction <span className="tx-form__optional">(optional)</span></label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                               value={form.helperDeduction} onChange={e => set('helperDeduction', e.target.value)}/>
                    </div>
                </div>
            )}

            {form.type === 'RATE_BASED' && (<>
                <div className="tx-form__row">
                    <div className="tx-form__field">
                        <label className="tx-form__label">Hourly Rate</label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                               value={form.rate} onChange={e => set('rate', e.target.value)} required/>
                    </div>
                    <div className="tx-form__field">
                        <label className="tx-form__label">Days</label>
                        <input className="tx-form__input" type="number" step="0.5" placeholder="20"
                               value={form.days} onChange={e => set('days', e.target.value)} required/>
                    </div>
                </div>
                <div className="tx-form__row">
                    <div className="tx-form__field">
                        <label className="tx-form__label">Share %</label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="100"
                               value={form.sharePercent} onChange={e => set('sharePercent', e.target.value)} required/>
                    </div>
                    <div className="tx-form__field">
                        <label className="tx-form__label">Deduction <span className="tx-form__optional">(optional)</span></label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                               value={form.helperDeduction} onChange={e => set('helperDeduction', e.target.value)}/>
                    </div>
                </div>
            </>)}

            {form.type === 'REVALUATION' && (
                <div className="tx-form__field">
                    <label className="tx-form__label">Adjustment (+ gain / − loss)</label>
                    <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                           value={form.adjustment} onChange={e => set('adjustment', e.target.value)} required/>
                </div>
            )}

            {gross != null && (
                <div className="tx-form__preview">
                    <span>Gross: <strong>{formatCurrency(gross, form.currencyCode || 'EUR')}</strong></span>
                </div>
            )}

            {form.type !== 'REVALUATION' && (
                <label className="tx-form__checkbox-label">
                    <input type="checkbox" checked={form.taxable !== false}
                           onChange={e => set('taxable', e.target.checked)}/>
                    Taxable
                </label>
            )}

            <div className="tx-form__field">
                <label className="tx-form__label">Notes <span className="tx-form__optional">(optional)</span></label>
                <textarea className="tx-form__input tx-form__textarea" value={form.notes}
                          onChange={e => set('notes', e.target.value)} rows={2}/>
            </div>

            <div className="tx-form__actions">
                <button type="button" className="tx-form__btn" onClick={onCancel}>Cancel</button>
                <button type="submit" className="tx-form__btn tx-form__btn--primary"
                        disabled={!canSubmit || saving}>
                    {saving ? 'Saving…' : editId ? 'Save' : 'Add Income'}
                </button>
            </div>
        </form>
    );
};

export default IncomeForm;
